export default "__VITE_ASSET__BKlypu5N__"